<tt-page class="col-xs-12 col-md-6 sp-0" *ngIf="!!menu">
    <tt-page-heading *ngIf="!!menu.page_heading" [ttModel]="menu.page_heading"></tt-page-heading>

    <tt-card>
        <tt-tabs [(ttSelectedId)]="selectedBgTravelBillMenuMain">
            <tt-tab ttId="OVERVIEW" ttLabel="gb_travelbillmenu_main_overview"></tt-tab>
            <tt-tab ttId="DETAILS" ttLabel="gb_travelbillmenu_main_details"></tt-tab>
            <tt-tab ttId="PROCESSING" ttLabel="gb_travelbillmenu_main_processing"></tt-tab>
        </tt-tabs>

        <tt-input ttLabel="travelbill_no" [ttModel]="menu.travelbill_no" ttReadonly></tt-input>
        <tt-input ttLabel="labour_name" [ttModel]="menu.labour_name" ttReadonly></tt-input>
        <tt-input *ngIf="menu.sr === '1'" ttLabel="special_hrsno" [ttModel]="menu.special_hrsno" [ttButtons]="specialHrsNoButtons" ttReadonly></tt-input>
        <tt-input *ngIf="menu.isexpence === '0'" ttLabel="travel_goal" [ttModel]="menu.travel_goal" ttReadonly></tt-input>
        <tt-input-number [hidden]="selectedBgTravelBillMenuMain === 'OVERVIEW'" ttLabel="sum_total" [ttModel]="menu.sum_total" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>

        <div [hidden]="selectedBgTravelBillMenuMain !== 'DETAILS'">
            <div *ngIf="menu.sr === '0'">
                <tt-input *ngIf="menu.cust_name === ''" ttLabel="cust_name" [ttModel]="menu.cust_name" ttReadonly></tt-input>
                <tt-input *ngIf="menu.cust_name !== ''" ttLabel="cust_name" [ttModel]="menu.cust_name" [ttButtons]="customerNameButtons" ttReadonly></tt-input>
                <tt-input *ngIf="menu.project_name === ''" ttLabel="project_name" [ttModel]="menu.project_name" ttReadonly></tt-input>
                <tt-input *ngIf="menu.project_name !== ''" ttLabel="project_name" [ttModel]="menu.project_name" [ttButtons]="projectNameButtons" ttReadonly></tt-input>
                <tt-input ttLabel="projectprosess_id_and_name" [ttModel]="menu.projectprosess_id_and_name" ttReadonly></tt-input>
            </div>

            <tt-input *ngIf="menu.custact_note !== ''" ttLabel="custact_note" [ttModel]="menu.custact_note" [ttButtons]="customerActivityNoteButtons" ttReadonly></tt-input>

            <div *ngIf="menu.isexpence === '0'">
                <tt-input ttLabel="place_of_departure" [ttModel]="menu.place_of_departure" ttReadonly></tt-input>
                <tt-input ttLabel="destination" [ttModel]="menu.destination" ttReadonly></tt-input>
            </div>

            <tt-datetime ttLabel="start_dt" [(ttModel)]="menu.start_dt"></tt-datetime>

            <div *ngIf="menu.isexpence === '0'">
                <tt-datetime ttLabel="end_dt" [(ttModel)]="menu.end_dt"></tt-datetime>
                <tt-input-number ttLabel="diet_days" [ttModel]="menu.diet_days" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
                <tt-input-number ttLabel="diet_hours" [ttModel]="menu.diet_hours" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
                <tt-input-number ttLabel="nights" [ttModel]="menu.nights" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
                <tt-input-number ttLabel="nbr_of_days" [ttModel]="menu.nbr_of_days" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
            </div>

            <tt-button-goto [ttText]="'travelbillmenu_edit'" [ttGoto]="'travelbill'" [ttGotoParms]="{ argtype: '-', argvalue: '-', travelbill_no: menu.travelbill_no }"></tt-button-goto>
        </div>

        <div [hidden]="selectedBgTravelBillMenuMain !== 'PROCESSING'">
            <div *ngIf="menu.sr === '1'">
                <tt-input ttLabel="special_resource_name_from" [ttModel]="menu.special_resource_name_from" ttReadonly></tt-input>
                <tt-input ttLabel="special_resource_name_processing" [ttModel]="menu.special_resource_name_processing" ttReadonly></tt-input>
            </div>
        </div>

        <tt-button-goto *ngIf="menu.isexpence === '0'" ttText="travelbillmenu_new_travelwage" ttGoto="travelwagedata" [ttGotoParms]="{ travelbill_no: menu.travelbill_no, travelwagedata_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        <tt-button ttText="travelbillmenu_travelexpence_new" (ttClick)="goToFunc('travelexpence')" ttIcon="far fa-plus"></tt-button>
        <tt-button *ngIf="menu.show_button_send_in === '1'" ttText="travelbillmenu_send_in" (ttClick)="sendChanges()" ttIcon="fas fa-paper-plane" ttType="success" [ttLoading]="sending"></tt-button>

        <div *ngIf="menu.show_buttons_approval === '1'">
            <tt-button ttText="travelbillmenu_approve" (ttClick)="approveChanges()" ttIcon="fas fa-check" ttType="success" [ttLoading]="approving"></tt-button>
            <tt-button ttText="travelbillmenu_reject" (ttClick)="goToFunc('travelbillreject')" ttIcon="fas fa-xmark" ttType="danger"></tt-button>
        </div>
    </tt-card>

    <tt-list-legacy [hidden]="selectedBgTravelBillMenuMain !== 'OVERVIEW'" [listItems]="itemsListTravelBills" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>
</tt-page>
